import { call, put, takeLatest } from "redux-saga/effects";
import {
  SAVE_CATEGORY_MASTER,
  DELETE_CATEGORY_ID,
  EDIT_CATEGORY_ID,
  GET_CATEGORY_LIST,
  UPDATE_CATEGORY_ID
} from "./actionTypes";
import {
  Post_ALL_Category_List_Api,
  Post_Category_API,
  detelet_Category_List_Api,
  edit_Category_List_Api,
  update_Category_List_Api
} from "../../../helpers/backend_helper";
import {
  categoryApiErrorAction,
  deleteCategoryIDSuccess,
  editCategoryIDSuccess,
  getCategorylistSuccess,
  saveCategoryMaster_Success,
  updateCategoryIDSuccess
} from "./action";
import { loginCompanyID } from "../../../components/Common/CommonFunction";

function* save_Method_ForCategory_GenFun({ config }) {              // Save API
  try {
    const response = yield call(Post_Category_API, config);
    yield put(saveCategoryMaster_Success(response));
  } catch (error) { yield put(categoryApiErrorAction()) }
}

function* Get_Category_List_GenratorFunction() {
  const jsonBody = JSON.stringify({
    CompanyID: loginCompanyID()
  });
  try {
    const response = yield call(Post_ALL_Category_List_Api, { jsonBody });
    yield put(getCategorylistSuccess(response.Data));
  } catch (error) { yield put(categoryApiErrorAction()) }
}

function* Delete_Category_ID_GenratorFunction({ config }) {          // delete API
  try {
    const response = yield call(detelet_Category_List_Api, config);
    yield put(deleteCategoryIDSuccess(response))
  } catch (error) { yield put(categoryApiErrorAction()) }
}

function* Edit_Category_ID_GenratorFunction({ config }) {           // edit API 
  const { btnmode } = config;
  try {
    const response = yield call(edit_Category_List_Api, config);
    response.pageMode = btnmode;
    yield put(editCategoryIDSuccess(response));
  } catch (error) { yield put(categoryApiErrorAction()) }
}


function* Update_Category_ID_GenratorFunction({ config }) {         // update API
  try {
    const response = yield call(update_Category_List_Api, config);
    yield put(updateCategoryIDSuccess(response))
  } catch (error) { yield put(categoryApiErrorAction()) }
}

function* CategorySaga() {
  yield takeLatest(SAVE_CATEGORY_MASTER, save_Method_ForCategory_GenFun)
  yield takeLatest(GET_CATEGORY_LIST, Get_Category_List_GenratorFunction)
  yield takeLatest(DELETE_CATEGORY_ID, Delete_Category_ID_GenratorFunction)
  yield takeLatest(EDIT_CATEGORY_ID, Edit_Category_ID_GenratorFunction)
  yield takeLatest(UPDATE_CATEGORY_ID, Update_Category_ID_GenratorFunction)
}

export default CategorySaga;